const fuzzyMatch = (item, searchString) => {
  let searchIndex = 0;
  let distance = 0;

  for (let i = 0; i < item.length; i++) {
    if (searchIndex < searchString.length && item[i] === searchString[searchIndex]) {
      searchIndex++;
    } else {
      distance++;
    }
  }

  return {
    match: searchIndex === searchString.length,
    distance: distance + (item.length - searchIndex - distance)
  };
};

export default fuzzyMatch;
